export const CLIENT_NAME_REGEX = /^$|^[\w+ ]+(?:\s*&\s*[\w+ ]+)*$/;

const TRAILING_AMPERSAND_REGEX = /&\s*$/;

export function getClientNameError(value: string): string | null {
  if (CLIENT_NAME_REGEX.test(value)) {
    return null;
  }

  if (TRAILING_AMPERSAND_REGEX.test(value)) {
    return 'Please type a character after "&" (e.g. M&M).';
  }

  return 'Value may only contain letters, numbers, underscores, and/or spaces.  Special characters not allowed.';
}
